import * as _4 from 'lodash4';
import { RegistrationErrorsQuery } from '../queries/registration_errors_query';
import { IRegistrationActivityDatasource } from '../../views/registration_transactions/datasources/registration_activity_datasource';

class RegistrationErrors {
  private showRegistrationErrorDetails = false;
  constructor(
    private ngRegistrationErrorsQuery: RegistrationErrorsQuery,
    private ngRegistrationActivityDatasource: IRegistrationActivityDatasource
  ) {}
  showRegistrationErrors() {
    this.showRegistrationErrorDetails = true;
  }
  errorDetailsPopupOpenedChanged($event: any) {
    if (!$event.detail.value) {
      this.closeRegistrationErrors();
    }
  }
  closeRegistrationErrors() {
    this.showRegistrationErrorDetails = false;
  }
  errorMessagesExist() {
    if (this.ngRegistrationErrorsQuery.result.hasErrorMessages) {
      return true;
    }
    this.closeRegistrationErrors();
    return false;
  }
}

class RegistrationErrorsComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {};
    this.controller = RegistrationErrors;
    this.templateUrl = 'capability-ng-scheduler/src/registration_errors/components/registration_errors.html';
  }
}
angular.module('capability-ng-scheduler').component('registrationErrors', new RegistrationErrorsComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_errors/components/registration_errors.ts